import getItemsToAdd from "../../../utils/getItemsToAdd";
import useTextFilter from "../../../hooks/useTextFilter";
import useFormMultiselector from "./useFormMultiselector";

const useFormListSelector = ({
  id,
  initialValue,
  idAsValue,
  options,
  onChange: handleChange,
  label,
}) => {
  const listAttributes = useFormMultiselector({
    id,
    initialValue,
    options,
    onChange: handleChange,
    idAsValue,
    label,
  });
  const { filteredData: filteredOptions, ...filterAttribs } = useTextFilter({
    data: getItemsToAdd(listAttributes.value, options),
    id: "label",
  });

  return {
    listAttributes: { ...listAttributes },
    filterAttribs,
    filteredOptions,
  };
};

export default useFormListSelector;
